/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiChargingSessionsStopChargingSessionSessionIdPost$Params {
  sessionId: number;
}

export function apiChargingSessionsStopChargingSessionSessionIdPost(http: HttpClient, rootUrl: string, params: ApiChargingSessionsStopChargingSessionSessionIdPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiChargingSessionsStopChargingSessionSessionIdPost.PATH, 'post');
  if (params) {
    rb.path('sessionId', params.sessionId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiChargingSessionsStopChargingSessionSessionIdPost.PATH = '/api/ChargingSessions/stopChargingSession/{sessionId}';
